export default "__VITE_ASSET__DPhtfpA1__"